import { Avatar, AvatarFallback, AvatarImage } from "ui";
import { getColorFromInitials, getContrastTextColor, getInitials } from "utils";

interface Props {
  name: string;
  src?: string;
  size?: "default" | "sm" | "lg";
}

export function UserAvatar(props: Props) {
  function renderFallback() {
    const initials = getInitials(props.name);
    const bgColor = getColorFromInitials(initials);
    const textColor = getContrastTextColor(bgColor);

    return (
      <AvatarFallback
        className="uppercase"
        style={{
          backgroundColor: bgColor,
          color: textColor,
        }}
        delayMs={props.src ? 300 : undefined}
      >
        {initials}
      </AvatarFallback>
    );
  }

  return (
    <Avatar size={props.size}>
      <AvatarImage src={props.src} />
      {renderFallback()}
    </Avatar>
  );
}
